/*
 dropdown

 Custom Knockout bindingHandler for rendering a Kendo UI dropdownlist.

 Expects the following values to be passed in:
 -- data (optional): array of data items or a function that returns an array of data items.
 -- dataPromise (optional): a function that returns a promise. 
 -- selectedIndex (optional): index of initial selected item
 -- selectedValue (optional): value of initial selected item. The selectedValue property overrides selectedIndex.
 -- onChange (optional): callback function upon change. The dropdown value will be passed to the callback.
 -- textField (optional) the data field to display for each item.
 -- valueField (optional) the data field to use as the value for each item.
 -- optionLabel (optional) the default option label object. Must contain properties with same names as the textField and valueField.

 */

import kendo from '@progress/kendo-ui';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';

var dropdownHandler = {};

//Custom dropdown binding handler
ko.bindingHandlers.dropdown = dropdownHandler = {

	update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		// This will be called once when the binding is first applied to an element,
		// and again whenever any observables/computeds that are accessed change
		// Update the DOM element based on the supplied values here.

		var props = valueAccessor();

		var textField = ko.isObservable(props.textField) ? props.textField() : props.textField;
		var valueField = ko.isObservable(props.valueField) ? props.valueField() : props.valueField;
		var dropdownDataSource = dropdownHandler.getDataSource(props);
		var optionLabel = dropdownHandler.getOptionLabel(props);
		var selectConfig = dropdownHandler.getSelectedItemConfig(props);
		var enabled = ko.isObservable(props.enabled) ? _.defaultIfNullOrUndefined(props.enabled(), true) : _.defaultIfNullOrUndefined(props.enabled, true);

		//Append a div that the kendo dropdownlist will be applied to.
		$(element).empty();
		var $dropdownElement = $("<div class='dropdowncontrol' style='width: 100%;' />").appendTo($(element));

		var dropdown = $dropdownElement.kendoDropDownList({
			dataTextField: textField,
			dataValueField: valueField,
			dataSource: dropdownDataSource,
			optionLabel: optionLabel,
			enable: enabled,
			index: selectConfig.selectedIndex,
			value: selectConfig.selectedValue,
			open: function (e) {
			  //Prevent dropdown from scrolling entire page
			  $("body").css("overflow", "hidden");
			},
			close: function (e) {
			  //Prevent dropdown from scrolling entire page
			  $("body").css("overflow", "visible");
			},
			change: function (e) {
				var value = dropdown.val();

				//If the selected value is an observable, just set it with the new value
				if (ko.isObservable(props.selectedValue))
					props.selectedValue(value);

				//If an onChange callback was defined, call it.
				if (props.onChange instanceof Function) {

					var onChange = ko.isObservable(props.onChange) ? props.onChange() : props.onChange;
					var args = ko.isObservable(props.onChangeArgs) ? props.onChangeArgs() : props.onChangeArgs;
					var dataItem = this.dataItem(this.selectedIndex);

					if (!_.isUndefined(args)) {
						onChange(value, dataItem, args)
					}
					else {
						onChange(value, dataItem);
					}
				}
			}
		});

	  //Prevent dropdown from scrolling entire page
		$dropdownElement.data("kendoDropDownList").element.on("focus", function () {
		  $("body").css("overflow", "hidden");
		});

	  //Prevent dropdown from scrolling entire page
		$dropdownElement.data("kendoDropDownList").element.on("blur", function () {
		  $("body").css("overflow", "visible");
		});
	},
	//Return an object containing the selected item config values (selectedIndex, selectedValue)
	getSelectedItemConfig: function (props) {

		var result = {};

		//If selectedValue was defined, use it
		result.selectedValue = ko.isObservable(props.selectedValue) ? props.selectedValue() : props.selectedValue;

		if (result.selectedValue)
			return result;

		//Use selectedIndex. If it wasn't defined just set the index to zero.
		result.selectedIndex = ko.isObservable(props.selectedIndex) ? props.selectedIndex() : props.selectedIndex || 0;

		return result;
	},
	//Return the optionLabel for the Kendo UI dropdownlist: http://docs.telerik.com/kendo-ui/api/javascript/ui/dropdownlist#configuration-optionLabel
	getOptionLabel: function (props) {

		if (_.isNullOrUndefined(props.optionLabel))
			return undefined;

		return ko.isObservable(props.optionLabel) ? props.optionLabel() : props.optionLabel;
	},
	getDataSource: function (props) {

		//If a promise was passed in, create a DataSource
		if (!_.isNullOrUndefined(props.dataPromise)) {

			var dataPromise = ko.isObservable(props.dataPromise) ? props.dataPromise() : props.dataPromise;
			var args = ko.isObservable(props.args) ? props.args() : props.args;

			return new kendo.data.DataSource({
				transport: {
					read: function (options) {
						dataPromise.apply(null, args).then(
						  function (results) {
						  	var resultsJS = ko.toJS(results);
						  	options.success(resultsJS);
						  },
						  function (errorResult) {
						  	options.error(errorResult);
						  });
					}
				}
			});
		}

		//Return the non-promise data source

		//Map all observable properties to JS.
		var dataResults = [];
		_.forEach(ko.isObservable(props.data) ? props.data() : props.data, function (data) {
			dataResults.push(ko.toJS(data));
		});

		return dataResults;
	}
};